/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */
/** @jsx jsx */

import { jsx } from '@emotion/react'
import { selectIsAddressOnBuilding } from '@zcode-ui/web-zumper-global-state'
import { AnalyticsC, Origin } from '@zcode/nr-utils'
import { useSelector } from 'react-redux'
import { StickyFormContainer } from './StickyFormContainer'
import { messageForm } from './styles'

export interface MessageFormProps {
  error: string | null
}

export const MessageForm = ({ error }: MessageFormProps) => {
  const isAddressOnBuilding = useSelector(selectIsAddressOnBuilding)
  if (error) {
    return null
  }

  return (
    <StickyFormContainer
      analyticChannel={AnalyticsC.PERMANENT_ADDRESS}
      headerText="Check availability"
      css={messageForm}
      origin={isAddressOnBuilding ? Origin.ADDR_ADDRESS_FORM : Origin.ADDRESS_FORM}
    />
  )
}
